import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  ready$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
}
